import i18n from 'i18next';
import translations from 'src/internationalisation/translation-map.json';
import { simulationStatuses } from 'src/enums/simulations';

export const getSimulationStatus = (statuses: string[]) => {
  if (statuses.some((status) => status === simulationStatuses.QUEUED)) {
    return simulationStatuses.QUEUED;
  }
  if (statuses.some((status) => status === simulationStatuses.INITIALISING)) {
    return simulationStatuses.INITIALISING;
  }
  if (statuses.some((status) => status === simulationStatuses.PREPARING_RESULTS)) {
    return simulationStatuses.PREPARING_RESULTS;
  }
  if (statuses.some((status) => status === simulationStatuses.FINISHED)) {
    return simulationStatuses.FINISHED;
  }
};

export const getLoaderText = (message: string | undefined, isGeneratingEstimates: boolean) => {
  if (message) {
    return message;
  }
  if (isGeneratingEstimates) {
    return i18n.t(translations.campaigns_generatingEstimates);
  }
  return i18n.t(translations.simulations_runningSimulations);
};
